import styled from 'styled-components';

export const StyledPreviewModal = styled.div<{
  brandColor: string;
  defaultHeight: boolean;
}>`
  min-height: ${(props) => (props.defaultHeight ? 'auto' : '500px')};
  max-height: 720px;
  height: auto;
  border-radius: 4px;
  background-color: #ebeff3;

  h3 {
    font-weight: bold;
    font-size: 24px;
    line-height: 24px;
    color: #12344d;
  }

  p {
    line-height: 24px;
    margin-top: 10px;
    text-align: center;
    color: #12344d;
    opacity: 0.5;
  }

  .welcome {
    padding: 80px 70px;
    background-repeat: repeat-x;
    background-position: top -10px center;
    max-width: 950px;
    height: 720px;

    p {
      margin: 20px 0;
      font-size: 16px;
      padding: 0 30px;
      line-height: 28px;
      max-width: 500px;
    }
  }

  .customize {
    display: flex;
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;

    .form-content {
      height: 100%;
    }

    h3 {
      font-size: 18px;
      line-height: 24px;
      color: #12344d;
      margin: 0;
    }

    &-form {
      width: 410px;
      min-width: 410px;
      max-height: 90vh;
      padding: 15px;
      display: flex;
      background: #fff;
      text-align: left;
      flex-direction: column;

      p {
        font-size: 14px;
        line-height: 24px;
        color: #12344d;
        text-align: left;
        opacity: 0.5;
        margin-bottom: 0;
      }
    }
    &-preview {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 10px;
      flex-grow: 1;
      height: 100%;
      min-height: 500px;

      &-content {
        width: 520px;
      }
      h3 {
        word-break: break-all;
      }

      .nps-card {
        width: 640px;
        max-width: 90%;
        padding: 24px;
        background: #ffffff;
        box-shadow: 0px 1.69143px 4.22857px rgba(18, 52, 77, 0.1);
        border-radius: 3.38286px;
      }

      .question-text {
        font-size: 1rem;
        font-weight: 600;
        line-height: 1.8;
        width: 100%;
        text-align: left;
        color: #12344d;
      }

      .help-text-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 0;

        .negative-text {
          color: #475867;
          bottom: -40px;
          font-size: 12px;
          left: 0;
          text-align: left;
        }

        .positive-text {
          color: #475867;
          bottom: -40px;
          font-size: 12px;
          right: 0px;
          text-align: right;
        }
      }
      .footer {
        border-top: 1px solid #ebeff3;
        padding-top: 20px;
        display: flex;
        justify-content: center;
        font-size: 0.875rem;
        line-height: 1.5;
        color: #666;
      }

      .nps-scale {
        display: flex;
        background: #f1f1f1;
        border-radius: 4px;
        justify-content: space-between;
        height: 32px;

        .number {
          display: flex;
          align-items: center;
          justify-content: center;
          min-width: 32px;
          height: 32px;
          font-size: 14px;

          &.selected {
            color: #fff;
            background: ${(props) => props.brandColor};
            border: 1px solid ${(props) => props.brandColor};
            border-radius: 25px;
          }
        }
      }
      .nps-label {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        padding-bottom: 10px;
        margin-bottom: 20px;
        border-bottom: 1px solid var(--color-smoke-50);
      }
    }
  }
  .customize label.input-label {
    text-align: left;
    color: #475867;
    font-weight: 600;
    padding-bottom: 5px;
  }

  .input-helper {
    text-align: left;
  }

  .label {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    color: var(--color-elephant-900);
    margin-bottom: 4px;
    div {
      display: block !important;
    }
  }

  .welcome {
    background-image: url("data:image/svg+xml,%3Csvg width='600' height='90' viewBox='0 0 600 90' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='42' y='-10' width='6' height='10'/%3E%3Crect x='84' y='-10' width='6' height='10'/%3E%3Crect x='126' y='-13' width='5' height='13'/%3E%3Crect x='168' y='-13' width='5' height='13'/%3E%3Crect x='210' y='-10' width='6' height='10'/%3E%3Crect x='252' y='-13' width='5' height='13'/%3E%3Crect x='294' y='-10' width='6' height='10'/%3E%3Crect x='336' y='-13' width='5' height='13'/%3E%3Crect x='378' y='-13' width='5' height='13'/%3E%3Crect x='420' y='-10' width='6' height='10'/%3E%3Crect x='462' y='-10' width='6' height='10'/%3E%3Crect x='504' y='-13' width='5' height='13'/%3E%3Crect x='546' y='-10' width='6' height='10'/%3E%3Cstyle type='text/css'%3E rect %7B opacity: 0; %7D rect:nth-child(1) %7B transform-origin: 45px 5px; transform: rotate(-145deg); animation: blast 700ms infinite ease-out; animation-delay: 88ms; animation-duration: 631ms; %7D rect:nth-child(2) %7B transform-origin: 87px 5px; transform: rotate(164deg); animation: blast 700ms infinite ease-out; animation-delay: 131ms; animation-duration: 442ms; %7D rect:nth-child(3) %7B transform-origin: 128px 6px; transform: rotate(4deg); animation: blast 700ms infinite ease-out; animation-delay: 92ms; animation-duration: 662ms; %7D rect:nth-child(4) %7B transform-origin: 170px 6px; transform: rotate(-175deg); animation: blast 700ms infinite ease-out; animation-delay: 17ms; animation-duration: 593ms; %7D rect:nth-child(5) %7B transform-origin: 213px 5px; transform: rotate(-97deg); animation: blast 700ms infinite ease-out; animation-delay: 122ms; animation-duration: 476ms; %7D rect:nth-child(6) %7B transform-origin: 255px 6px; transform: rotate(57deg); animation: blast 700ms infinite ease-out; animation-delay: 271ms; animation-duration: 381ms; %7D rect:nth-child(7) %7B transform-origin: 297px 5px; transform: rotate(-46deg); animation: blast 700ms infinite ease-out; animation-delay: 131ms; animation-duration: 619ms; %7D rect:nth-child(8) %7B transform-origin: 338px 6px; transform: rotate(-65deg); animation: blast 700ms infinite ease-out; animation-delay: 85ms; animation-duration: 668ms; %7D rect:nth-child(9) %7B transform-origin: 380px 6px; transform: rotate(13deg); animation: blast 700ms infinite ease-out; animation-delay: 128ms; animation-duration: 377ms; %7D rect:nth-child(10) %7B transform-origin: 423px 5px; transform: rotate(176deg); animation: blast 700ms infinite ease-out; animation-delay: 311ms; animation-duration: 508ms; %7D rect:nth-child(11) %7B transform-origin: 465px 5px; transform: rotate(108deg); animation: blast 700ms infinite ease-out; animation-delay: 108ms; animation-duration: 595ms; %7D rect:nth-child(12) %7B transform-origin: 506px 6px; transform: rotate(62deg); animation: blast 700ms infinite ease-out; animation-delay: 105ms; animation-duration: 375ms; %7D rect:nth-child(13) %7B transform-origin: 549px 5px; transform: rotate(16deg); animation: blast 700ms infinite ease-out; animation-delay: 149ms; animation-duration: 491ms; %7D rect:nth-child(odd) %7B fill: %2365BB5C; %7D rect:nth-child(even) %7B z-index: 1; fill: %2333AAFF; %7D rect:nth-child(4n) %7B animation-duration: 1400ms; fill: %23F23B14; %7D rect:nth-child(3n) %7B animation-duration: 1750ms; animation-delay: 700ms; %7D rect:nth-child(4n-7) %7B fill: %232A2F6A; %7D rect:nth-child(6n) %7B fill: %23FBBA23; %7D @keyframes blast %7B from %7B opacity: 0; %7D 20%25 %7B opacity: 1; %7D to %7B transform: translateY(90px); %7D %7D %3C/style%3E%3C/svg%3E%0A");
  }
`;

export const ColorPreview = styled.div`
  height: 25px;
  width: 25px;
  margin: 5px;
  border-radius: 5px;
`;

export const OnboardingSetupWizard = styled.div`
  display: flex;
  height: auto;
  height: 720px;
  border-radius: 4px;

  .customize-preview {
    position: relative;

    .preview-info {
      position: absolute;
      bottom: 8px;
      z-index: 1;
      transform: translateX(-50%);
      left: 50%;
      padding: 8px 16px 8px 6px;
      background: rgb(224, 230, 236);
      border-radius: 4px;
      margin-bottom: 12px;
      border: none;
      font-style: italic;
      font-size: 14px;
      line-height: 20px;
      color: rgb(18, 52, 77);
      display: flex;
      -webkit-box-align: center;
      align-items: center;
      width: fit-content;
      white-space: nowrap;
    }
  }

  .setup-content {
    border-radius: 4px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 410px;
    min-width: 410px;
    min-height: 600px;
    height: auto;

    &-header {
      padding: 20px 20px 0;

      .subtitle {
        font-size: 13px;
        text-align: left;
        color: var(--color-smoke-800);
        margin: 4px 0 20px;
        opacity: 1;
      }
      .title {
        font-weight: bold;
        font-size: 18px;
        line-height: 24px;
        color: #12344d;
        display: flex;
        align-items: center;
        margin-bottom: 0;
      }
    }

    &-body {
      padding: 5px 20px 20px;
      flex-grow: 1;
      overflow-y: auto;

      .input-label {
        text-align: left;
      }
    }

    &-actions {
      padding: 20px 10px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-shadow: 0px -3px 4px rgba(207, 215, 223, 0.3);

      button {
        display: flex;
        align-items: center;

        .icon {
          margin-left: 5px;
        }
      }
    }
  }

  .setup-preview {
    height: 100%;
    width: 100%;
    flex-grow: 1;
    overflow: auto;
    min-height: 600px;
  }
`;
